export function formatDuration(input: unknown): string {
  const n = typeof input === 'number' ? input : Number(input)

  if (!Number.isFinite(n) || n <= 0) return ''

  const totalSeconds = Math.floor(n)

  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const mm = String(minutes).padStart(2, '0')
  const ss = String(seconds).padStart(2, '0')

  // If it’s over an hour, show H:MM:SS
  if (hours > 0) {
    const hh = String(hours)
    return `${hh}:${mm}:${ss}`
  }

  return `${mm}:${ss}`
}